export default "__VITE_ASSET__DxaOoiPz__"